import Content from "./content";
import { node } from "~/util/dom";
import { addFirmWithDestination, createDetailItem, reportWaitForLogin, getMapAddressData, reportAnalytics } from "~/report/util";
import { isPointInStatePolygon } from "~/util/state-polygon";
import { default as ReportForm } from "~/report";
import { getSuggestDataOptions, getAddPlaceOptions, getOpenAgainOptions } from "~/report/options";
import { _ } from "~/i18n";
import { IPoi } from "~/interfaces";

export const NON_REPORTED_POITYPES = [970, 971, 972, 973, 974, 975];

export function reportPoiType(poiTypeId: number): boolean {
	return NON_REPORTED_POITYPES.indexOf(poiTypeId) === -1;
}

export default class Report extends Content {
	_build() {
		this._dom.container.classList.add("content-report");

		const data: IPoi = this._data.data;

		// preskakujeme
		if (["wcam"].includes(data.source)) {
			return;
		}

		const reportItems = node("div", { className: "contact-report-items" });
		const coords = data.coords.toWGS84();
		const address = data.source === "addr"
			? data.title.split(",")[0]
			: data.source === "coor"
				? data.id
				: data.title;
		const addressData = getMapAddressData(data);

		isPointInStatePolygon(coords[0], coords[1], {
			cs: true,
		}).then(isCzechia => {
			const cz = isCzechia ? 1 : 0;

			// pridat chybejici misto
			function addLocation() {
				return createDetailItem("report-add-location", _("report.addPlace2"), async () => {
					reportAnalytics({
						text: "Přidat chybějící místo",
						origin: "poi",
						type: "missingPlace",
						source: data.source,
						cz,
					});

					await reportWaitForLogin();

					const report = new ReportForm(getAddPlaceOptions({
						values: {
							"name": address,
							address,
							"address-data": addressData,
						},
						analytics: {
							type: "missingPlace",
							origin: "poi",
							source: data.source,
							cz,
						},
						coords: {
							lon: coords[0],
							lat: coords[1],
						},
					}));

					report.open();
				});
			}

			// pridat svou firmu
			function addBussiness() {
				return createDetailItem("report-add-business", _("report.addFirm"), () => {
					reportAnalytics({
						text: "Přidat svou firmu",
						origin: "poi",
						type: isCzechia ? "goToFirmy" : "addOsmFirm",
						source: data.source,
					});
					addFirmWithDestination(isCzechia, {
						type: isCzechia ? "missingPlace" : "addOsmFirm",
						origin: "poi",
						source: data.source,
						cz,
					}, {
						"name": address,
						address,
						"address-data": addressData,
					}, {
						lon: coords[0],
						lat: coords[1],
					});
				});
			}

			// navrhnout upravu
			function addDataEdit() {
				return createDetailItem("report-edit-location", _("report.suggestEditData"), async () => {
					reportAnalytics({
						text: "Navrhnout úpravu údajů",
						origin: "poi",
						type: "editPlace",
						source: data.source,
						cz,
					}, "error_report");

					await reportWaitForLogin();

					const report = new ReportForm(getSuggestDataOptions(data, () => reportAnalytics({
						text: "goToNextStep",
						origin: "poi",
						type: "editPlaceNextStep",
						source: data.source,
						cz: isCzechia ? 1 : 0,
					}, "error_report")));

					report.open();
				});
			}

			// navrhnout znovuotevreni POIe
			function addOpenAgain() {
				return createDetailItem("report-edit-location", _("report.suggestOpenAgain"), async () => {
					reportAnalytics({
						text: "Je toto místo znovu otevřené?",
						origin: "poi",
						type: "editPlace",
						source: data.source,
						cz,
					}, "error_report");

					await reportWaitForLogin();

					const report = new ReportForm(getOpenAgainOptions(data));

					report.open();
				});
			}

			const items = [];

			if (data.source === "osm") {
				items.push(
					...isCzechia
						? [addDataEdit()]
						: [
							// osmd - osm adresa; osms - osm street
							...data.origin === "osmd"
								? [
									addLocation(),
									addBussiness(),
								]
								: [
									data.inactive ? addOpenAgain() : addDataEdit(),
								],
						],
				);
			// souradnice/adresni bod
			} else if (["addr", "coor"].indexOf(data.source) !== -1) {
				items.push(
					addLocation(),
					addBussiness(),
				);
			// nahrada za kontakty
			} else if (data.extend.contact || (!data.extend.contact && !data.anonymized && data.source !== "coor")) {
				items.push(
					data.inactive ? addOpenAgain() : addDataEdit(),
				);
			}

			reportItems.append(...items);

			if (items.length === 0) {
				this._dom.container.classList.add("empty");
			}

			this._dom.container.appendChild(reportItems);
		}, () => {});
	}
}
